import { render, staticRenderFns } from "./ServiceWorks.vue?vue&type=template&id=fcbae9b2&"
import script from "./ServiceWorks.vue?vue&type=script&lang=js&"
export * from "./ServiceWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports